var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.781 7.75A6.78 6.78 0 0 0 7 .969 6.78 6.78 0 0 0 .219 7.75c0 3.39 2.46 6.207 5.715 6.7V9.718H4.21V7.75h1.723V6.273c0-1.695 1.011-2.652 2.543-2.652.765 0 1.53.137 1.53.137v1.668H9.16c-.848 0-1.12.52-1.12 1.066V7.75h1.886l-.301 1.969H8.039v4.73a6.77 6.77 0 0 0 5.742-6.699"
})));
export default SvgFacebookLogo;